import { useQuery } from '@apollo/client';
import {
  GET_LIST_PROMOTED_TWEETS,
  GET_LIST_TWEET_AD_STATUS,
} from '../../graphql/queries';
import { socmedType } from '../../configs/socmedType';

const TwitterMediaHandler = (props) => {
  const {
    accountId,
    accountType,
    lineItemIds,
    setLoading,
    setLoadingMedia,
    adTweets = [],
  } = props;
  const { data: dataPromotedTweets } = useQuery(GET_LIST_PROMOTED_TWEETS, {
    variables: {
      request: {
        user_socmed_id: accountId,
        with_deleted: false,
        line_item_ids: lineItemIds,
      },
    },
    skip: accountType !== socmedType.TWT,
  });
  const listPromotedTweets =
    dataPromotedTweets?.GetListPromotedTweets?.data || [];
  const promotedTweet = listPromotedTweets?.[0] || {};
  const tweetId = promotedTweet?.tweet_id_str || promotedTweet?.tweet_id;

  const { data: dataListTweet } = useQuery(GET_LIST_TWEET_AD_STATUS, {
    variables: {
      request: {
        user_socmed_id: accountId,
        tweet_type: 'PUBLISHED',
        timeline_type: 'ALL',
        tweet_ids: tweetId,
      },
    },
    skip: accountType !== socmedType.TWT,
    onCompleted: () => {
      if (setLoading) setLoading(false);
      setLoadingMedia(false);
    },
    onError: () => {
      if (setLoading) setLoading(false);
      setLoadingMedia(false);
    },
  });

  const listTweet = dataListTweet?.list?.data || [];
  const postList = listTweet?.map((item) => {
    const medias = item?.extended_entities?.media || [];
    return medias?.map((media) => {
      return {
        image: media?.media_url,
      };
    });
  });

  const adTweet = adTweets?.map((item) => {
    const medias = item?.extended_entities?.media || [];
    return medias?.map((media) => {
      return {
        image: media?.media_url,
      };
    });
  });

  if (postList?.[0]?.length > 0) {
    return postList?.[0];
  }
  if (adTweet?.[0]?.length > 0) {
    return adTweet?.[0];
  }
  return [];
};

export default TwitterMediaHandler;
